
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/quickEdit/components/styles/buttonDesignEntryPoint.scss.css.virtualfile';
        module.exports = {"buttonDesignEntryPoint":"_buttonDesignEntryPoint_1juf4_7","link":"_link_1juf4_10"};